function StateAndDescription({icon, description}) {
    return (
        <div>
            {icon} {description}
        </div>
    );
}

export default StateAndDescription;